import Vue from 'vue'
import VueI18n from 'vue-i18n'
import countries from 'i18n-iso-countries'

Vue.use(VueI18n)

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = messages[locale] ? Object.assign(messages[locale], locales(key)) : locales(key)
        }
    })
    return messages
}
const messages = loadLocaleMessages()
const lang = navigator.language.slice(0, 2)
const languages = Object.keys(messages)
let locale = languages.includes(lang) ? lang : 'en'
let localStor = window.localStorage.getItem('localeValue');
if (localStor != null && localStor != '') {
    locale = languages.includes(localStor) ? localStor : locale
}


const html = document.documentElement
html.setAttribute('lang', locale)

countries.isCountryCodeInEU = (country) => {
    const countries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HU', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK']

    return countries.includes(country)
}

countries.isFrenchTerritory = (country) => {
    const countries = ['FR', 'GP', 'MQ', 'GF', 'RE', 'YT', 'MF', 'PM', 'BL', 'WF', 'PF', 'NC', 'TF']

    return countries.includes(country)
}

countries.registerLocale(require("i18n-iso-countries/langs/fr.json"))
countries.registerLocale(require("i18n-iso-countries/langs/en.json"))
countries.registerLocale(require("i18n-iso-countries/langs/es.json"))
countries.registerLocale(require("i18n-iso-countries/langs/it.json"))
countries.registerLocale(require("i18n-iso-countries/langs/pt.json"))
countries.registerLocale(require("i18n-iso-countries/langs/ro.json"))
countries.registerLocale(require("i18n-iso-countries/langs/es.json"))

const dateTimeFormats = {
    'en': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'fr': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'it': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'de': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'pt': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'ro': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    },
    'es': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        }
    }
}


const i18n = new VueI18n({
    locale: locale,
    messages,
    dateTimeFormats,
    silentTranslationWarn: true,
    fallbackLocale: 'en'
})

i18n.availableLocalesLabels = [
    {
        value: 'en',
        text: 'English'
    },
    {
        value: 'fr',
        text: 'Français'
    },
    {
        value: 'es',
        text: 'Español'
    },
    {
        value: 'it',
        text: 'Italiano'
    },
    {
        value: 'de',
        text: 'Deutsche'
    },
    {
        value: 'pt',
        text: 'Português'
    },
    {
        value: 'ro',
        text: 'Română'
    }
]

export { i18n }
